import * as React from 'react';

export const IconCianJournal = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 7.5C12 7.5 8 5 3 5V18.1765C8 18.1765 12 21 12 21C12 21 16 18.1765 21 18.1765V5C19.5598 5 18.2026 5.20742 17 5.50276"
        stroke="#152242"
        strokeWidth="2"
      />
      <path
        d="M17 15V2C17 2 13 3 12 6.61201V21C13 16.5 17 15 17 15Z"
        stroke="#152242"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
